import React from "react";
import { ArrowUpRight } from "lucide-react";
import { COURSES } from "../../config/site";
import { Reveal, useEnquiry } from "../../lib/site-ui";

export const Courses = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="courses" className="relative py-24 sm:py-32 lg:py-40" data-testid="courses-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <Reveal as="p" className="label-mono text-slate-500 mb-4">01 — Subjects</Reveal>
            <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-2xl">
              DGCA Ground Coaching
            </Reveal>
          </div>
          <Reveal className="max-w-sm text-slate-400 leading-relaxed lg:text-right">
            Focused, concept-first preparation across every DGCA subject — taught to be understood, not memorised.
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {COURSES.map((c, i) => (
            <Reveal key={c.id} delay={(i % 3) * 0.08}>
              <div className="group relative bg-slate-950 hover:bg-slate-900 transition-colors duration-300 p-8 h-full flex flex-col" data-testid={`course-card-${c.id}`}>
                <span className="label-mono text-slate-600 mb-8 block">0{i + 1}</span>
                <h3 className="font-display text-2xl text-white mb-3 tracking-tight">{c.name}</h3>
                <p className="text-slate-400 leading-relaxed mb-8 flex-1">{c.desc}</p>
                <button
                  data-testid={`course-enquire-${c.id}`}
                  onClick={() => openEnquiry({ course: c.name })}
                  className="inline-flex items-center gap-2 text-sm text-white/90 group-hover:text-white transition-colors"
                >
                  Enquire Now
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
